var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenDarkIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#112818;}.cls-3{fill:#24733a;}.cls-4{fill:#0f1a14;}.cls-5{fill:#0d110f;}.cls-6{fill:#0c130f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,230.12C517.13,227.76,318.89,21.66,311,13.33c-8.55-8.94-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.09-14.29-.79-14.29-.79s-4-5.24-17.63-1.29C233.58,13.71,7.86,71.07,7.86,71.07S.77,72.89.69,80.16,0,124.91,0,124.91,195.25,376.29,202.91,386.25c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232.23,519.39,230.12Zm-98.51-57.86-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.72,165C425.36,167.78,424.54,171.06,420.88,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.22,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C244,5.24,55.94,53,55.94,53S50,54.56,50,60.61s-.58,37.3-.58,37.3S212.1,307.39,218.48,315.69c5.23,6.83,18.36,2.08,18.36,2.08S473.57,232,479.09,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S483.86,187.34,482.22,185.58Zm-61.34-13.32-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.72,165C425.36,167.78,424.54,171.06,420.88,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M479.6,182.73S315.13,11.75,308.51,4.81c-7.12-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S268.63-2,257.23,1.31C244,5.12,55.94,52.93,55.94,52.93s-8.71,3-3.6,9.42c5.37,7.05,48.6,63.65,48.6,63.65s107.5,135.24,115.55,145.29,23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S479.6,182.73,479.6,182.73Zm-58.72-10.47-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.72,165C425.36,167.78,424.54,171.06,420.88,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "241.3 281.15 241.3 308.67 474.11 224.48 474.11 201.17 241.3 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.11 201.17 457.77 206.84 474.11 224.48 474.11 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.64,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.6,15.6,0,0,0,228.24,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.6,182.73S409.07,109.41,358.53,56.84l-4.08,1.74L481.86,191.4C484.89,187.58,479.6,182.73,479.6,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.18,58.53c-8.48,2.19-26.72,8.67-16.64,21.56S124.47,93.35,142,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8S268.34,18.41,254,22.2,124.66,56.33,116.18,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.59,13.22l-2-2-25.09,6.74a30.56,30.56,0,0,1,3.68,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92,70.72,64.28,78.07l1.92,2.51L92,73.67A9.15,9.15,0,0,1,92,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.8,17.6l-1.95-2-22.27,6A28.92,28.92,0,0,1,299,23.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.79,82.62l1.93,2.5L94,78.65A17.48,17.48,0,0,1,92.66,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.13,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.63.67.94,1S302.86,27.42,303.13,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.77,81.29,71.7,87.8l1.94,2.49L97.78,83.7c-.48-.53-1-1.08-1.42-1.65C96.14,81.79,96,81.54,95.77,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.42,92.56l1.94,2.49,25.17-6.89c-.87-.69-1.73-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,26.1l-1.94-2-22.24,6.05A17,17,0,0,1,306,32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.62,96.8l1.95,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.77,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,306.77,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M428.83,165.28,329.22,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.19,4.17l190.15-63.39C431.17,173.1,432.23,168.87,428.83,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.35-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.72,165C425.36,167.78,424.54,171.06,420.88,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.65,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.31-7.3c3.14-1,5.28.8,4.75,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDarkIsometric);
export default __webpack_public_path__ + "static/media/green-dark-isometric.c1bfb9f808b778184ad3454130ee8905.svg";
export { ForwardRef as ReactComponent };